import React, { Component, Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropdownListItem from "../DropdownContainer/DropdownListItem";
import { GlobalUtils } from "../../../utils";
// destructuring
const { truncateString } = GlobalUtils;

class UserGroupRoles extends Component {
  state = {};

  render() {
    const { type, listItems, templateId, docID, id } = this.props;

    return (
      <ul className="dropdowncontainer-list">
        {type === "userGroups" && listItems.length > 0 ? (
          <Fragment>
            {this.props.templateUsergroups.length > 0 ? (
              <Fragment>
                <div className="dropdown-list-item-usergroup">
                  {this.props.templateUsergroups.map(item => (
                    <div
                      className="dropdown-user"
                      onClick={() =>
                        this.props.deleteUserGroup(item, templateId)
                      }
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="0">
                      {item.name ? truncateString(item.name, 17, true) : null}
                      <i className="close-icon">
                        <FontAwesomeIcon icon={["far", "times"]} />
                      </i>
                    </div>
                  ))}
                </div>
                <div className="divide-line" />
              </Fragment>
            ) : (
              <Fragment>
                <div className="dropdown-list-item-empty">Select a group</div>
              </Fragment>
            )}
          </Fragment>
        ) : null}
        {type === "userGroups" && listItems.length <= 0 ? (
          <Fragment>
            <div className="dropdown-list-item-empty">
              <FontAwesomeIcon
                icon={["far", "exclamation-circle"]}
                className="dropdown-icon-empty"
              />
              You do not have any User <br />
              Groups created.
            </div>
          </Fragment>
        ) : (
          listItems &&
          listItems.map(item => (
            <DropdownListItem
              docID={docID}
              templateId={templateId}
              className="dropdowncontainer-list-item"
              type={type}
              item={item}
              key={`${item.id}-${type}listitem${id}`}
              changeDocumentStatus={this.props.changeDocumentStatus}
              onKeyPress={() => {}}
            />
          ))
        )}
        {type === "userGroups" ? (
          <div
            onClick={e => this.props.addNewUsergroup(e)}
            onKeyPress={() => {}}
            data-id={`addedit${id}`}
            role="button"
            tabIndex="0"
            className="add-another-usergroup-wrapper">
            <i className="plusicon" data-test="dropdowncontainer-new-user-btn">
              <FontAwesomeIcon icon={["far", "plus"]} className="" />
            </i>
            <div className="add-another-user-btn">
              <div className="add-another-user-title">New users groups</div>
            </div>
          </div>
        ) : null}
      </ul>
    );
  }
}

export default UserGroupRoles;
